import {User} from '../../user/models/user.models';
import {UserGroup} from '../../user/modules/user-groups/user-group.models';
import {Category} from '../../category/models/category.models';
import {OvpJobCondition} from '../../ovp/models/ovp-job-condition.models';

export class Company {
    /** @type {string} */
    _id = '';

    /** @type {string} */
    name = '';

    /** @type {string} */
    email = '';

    /** @type {string} */
    logo = '';

    /** @type {string} */
    ovpName = '';

    /** @type {string} */
    ovpRegNumber = '';

    /** @type {string} */
    ovpAddress = '';

    /** @type {string} */
    createdAt = '';

    /** @type {string} */
    updatedAt = '';

    /** @type {User[]} */
    users = [];

    /** @type {User[]} */
    usersGroups = [];

    /** @type {Category[]} */
    categories = [];

    /** @type {OvpJobCondition[]} */
    ovpJobConditions = [];


    /**
     * @param {Object} obj
     * @returns {Company}
     */
    static fromArray(obj) {
        if (obj && obj.users && obj.users.length) {
            obj.users = obj.users.map(user => User.fromArray(user));
        }

        if (obj && obj.usersGroups && obj.usersGroups.length) {
            obj.usersGroups = obj.usersGroups.map(userGroup => UserGroup.fromArray(userGroup));
        }

        if (obj && obj.categories && obj.categories.length) {
            obj.categories = obj.categories.map(category => Category.fromArray(category));
        }

        if (obj && obj.ovpJobConditions && obj.ovpJobConditions.length) {
            obj.ovpJobConditions = obj.ovpJobConditions.map(ovpCondition => OvpJobCondition.fromArray(ovpCondition));
        }

        return Object.assign(new this, obj || {});
    }

    get logoPath() {
        return this.logo || '/img/logo-placeholder.png';
    }

    cleanUp() {
        delete this.users;
        delete this.categories;
        delete this.usersGroups;
        delete this.usersGroups;

        return this;
    }
}